var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.load
      ? _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [_c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.load
      ? _c(
          "form",
          {
            staticClass: "md-layout",
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateChain($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "md-layout-item md-size-100" },
              [
                _c("div", { staticClass: "md-title" }, [_vm._v("Chain Info")]),
                _vm._v(" "),
                _vm.logoPreview !== null
                  ? _c("img", {
                      staticClass: "chain-logo",
                      attrs: { src: _vm.logoPreview }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "name",
                        attrs: {
                          fieldName: "name",
                          validations: { required: true },
                          fieldValue: _vm.form.name,
                          fieldLabel: "Name",
                          fieldId: "name",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "address",
                        attrs: {
                          fieldName: "address",
                          fieldValue: _vm.form.address,
                          fieldLabel: "Address",
                          fieldId: "address",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field-select", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "language",
                        attrs: {
                          fieldName: "languageId",
                          fieldValue: _vm.form.languageId,
                          fieldLabel: "Chain Language",
                          fieldId: "language",
                          values: _vm.languages,
                          valueId: "id",
                          valueLabel: "name",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field-select", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "timezone",
                        attrs: {
                          fieldName: "timezone",
                          fieldValue: _vm.form.timeZoneId,
                          fieldLabel: "Timezone",
                          fieldId: "timezone",
                          values: _vm.timezones,
                          valueId: "timeZoneId",
                          valueLabel: "name",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field-select", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "measurementSystem",
                        attrs: {
                          fieldName: "measurementSystem",
                          fieldValue: _vm.form.measurementSystem,
                          fieldLabel: "Measurement system",
                          fieldId: "measurementSystem",
                          values: _vm.measurementSystems,
                          valueId: "measurement",
                          valueLabel: "name",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field-select", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "country",
                        attrs: {
                          fieldName: "country",
                          fieldValue: _vm.form.countryId,
                          fieldLabel: "Country",
                          fieldId: "country",
                          values: _vm.countries,
                          valueId: "countryId",
                          valueLabel: "name",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "postcode",
                        attrs: {
                          fieldName: "zipCode",
                          fieldValue: _vm.form.zipCode,
                          fieldLabel: "Zip code",
                          fieldId: "zipCode",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "childComponent",
                        attrs: {
                          fieldName: "stateProvince",
                          fieldValue: _vm.form.stateProvince,
                          fieldLabel: "Province",
                          fieldId: "stateProvince",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "phoneNumber",
                        attrs: {
                          fieldName: "phoneNumber",
                          fieldValue: _vm.form.phoneNumber,
                          fieldLabel: "Phone number",
                          fieldId: "phone-number",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "email",
                        attrs: {
                          fieldName: "email",
                          validations: { email: true },
                          fieldValue: _vm.form.email,
                          fieldLabel: "Email",
                          fieldId: "email",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-small-size-100" },
                    [
                      _c("field", {
                        directives: [
                          { name: "can-edit", rawName: "v-can-edit" }
                        ],
                        ref: "website",
                        attrs: {
                          fieldName: "website",
                          fieldValue: _vm.form.website,
                          fieldLabel: "Website",
                          fieldId: "website",
                          sending: _vm.sending
                        },
                        on: {
                          setfield: function($event) {
                            return _vm.setFormField($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.sending
                  ? _c("md-progress-bar", {
                      attrs: { "md-mode": "indeterminate" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout md-gutter" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-small-size-100 right-align"
                    },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-primary",
                          attrs: { type: "submit", disabled: _vm.sending }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f928759", { render: render, staticRenderFns: staticRenderFns })
  }
}